// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"276":"4627a77d","453":"cc799dce"}[chunkId] + ".chunk.js";
};